import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import i18n from "./i18n";

function LanguageSync() {
  const { i18n } = useTranslation();
  useEffect(() => {
    document.documentElement.lang = i18n.language || "en";
  }, [i18n.language]);
  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <LanguageSync />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;